import { SET_EXCHANGE } from "./types";

export const ExchangesReducer = (exchanges = null, { type, payload }) => {
  switch (type) {
    case SET_EXCHANGE:
      return payload.exchanges || exchanges;
    default:
      return exchanges;
  }
};
